<template>
  <div class="min-h-screen flex flex-col justify-center gap-1 place-items-center text-center">
    <div class="text-2xl">
      Заказ успешно создан
    </div>
    <div>
      Для его оплаты вернитесь в бота
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.WebApp.disableClosingConfirmation()
    this.$store.commit('mb_hide')
  }
}
</script>
